import type { ReactNode } from 'react';

import { Card, Text, Title } from '@highlight-cp/core-ui';

import classes from './download-card.module.css';

export interface DownloadCardProps {
  /** SVG icon element rendered at the top of the card (teal circle icon) */
  icon: ReactNode;
  /** Bold title displayed below the icon */
  title: string;
  /** Description text displayed below the title */
  description: string;
  /** Action area content, typically a Button or Group of buttons */
  children: ReactNode;
}

export const DownloadCard = ({ icon, title, description, children }: DownloadCardProps) => (
  <Card h="100%">
    <div className={classes.icon}>{icon}</div>

    <Title order={3} mb="md">
      {title}
    </Title>

    <Text mb="sm">{description}</Text>

    <div>{children}</div>
  </Card>
);
